export { rulesIfAttempted } from '@/features/shipment/helpers/createShipmentValidation';

export type CommercialInvoiceValidationState = { attempted: boolean };
